export default "__VITE_ASSET__Coqfi0wY__"